import { render, staticRenderFns } from "./Devicedoorrecordtable.vue?vue&type=template&id=3837942c&scoped=true"
import script from "./Devicedoorrecordtable.vue?vue&type=script&lang=js"
export * from "./Devicedoorrecordtable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3837942c",
  null
  
)

export default component.exports